export default __webpack_public_path__ + "static/media/CalendarGreen.06af63f8.svg";